export const USER_BAN = 'user.banned';
export const USER_UNBAN = 'user.unbanned';
